var _desc, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCardOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.6.3")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.98 0 0 0.98 15.75 15.75)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -16,
    y: -16,
    rx: 0,
    ry: 0,
    width: 32,
    height: 32
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -16,
    y: -16,
    rx: 0,
    ry: 0,
    width: 32,
    height: 32
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-16, -16)",
    d: "m 16 31.00002 a 3.9 3.9 0 0 1 -1.92 -0.5 l -10.18 -5.67 a 3.63 3.63 0 0 1 -1.9 -3.16 l 0 -11.35 a 3.64 3.64 0 0 1 1.89 -3.15 l 10.19 -5.68 a 4 4 0 0 1 1.92 -0.49 a 3.91 3.91 0 0 1 1.93 0.5 l 10.17 5.67 a 3.63 3.63 0 0 1 1.9 3.16 l 0 11.35 a 3.64 3.64 0 0 1 -1.89 3.15 l -10.19 5.68 a 4 4 0 0 1 -1.92 0.49 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 -0.01)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(4,166,252)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-16, -15.99)",
    d: "m 16 2.00001 a 2.92 2.92 0 0 1 1.42 0.37 l 10.2 5.68 a 2.64 2.64 0 0 1 1.38 2.27 l 0 11.34 a 2.66 2.66 0 0 1 -1.38 2.34 l -10.18 5.63 a 3 3 0 0 1 -1.44 0.37 a 3 3 0 0 1 -1.43 -0.37 l -10.2 -5.63 a 2.64 2.64 0 0 1 -1.37 -2.32 l 0 -11.34 a 2.66 2.66 0 0 1 1.38 -2.34 l 10.18 -5.63 a 3 3 0 0 1 1.44 -0.37 l 0 0 m 0 -2 l 0 0 a 4.93 4.93 0 0 0 -2.4 0.62 l -10.19 5.68 a 4.62 4.62 0 0 0 -2.41 4 l 0 11.38 a 4.62 4.62 0 0 0 2.41 4 l 10.18 5.68 a 5 5 0 0 0 4.82 0 l 10.18 -5.66 a 4.62 4.62 0 0 0 2.41 -4 l 0 -11.38 a 4.62 4.62 0 0 0 -2.41 -4 l -10.18 -5.7 a 4.93 4.93 0 0 0 -2.41 -0.62 z",
    strokeLinecap: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.58 0 0 0.55 15.18 18.31)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -16,
    y: -16,
    rx: 0,
    ry: 0,
    width: 32,
    height: 32
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.4 0 0 0.4 0.67 -4.67)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#012670",
    style: {
      fill: "#012670",
      stroke: "rgb(0,0,0)",
      strokeWidth: 0.6,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      opacity: 1
    },
    transform: " translate(-99.89, -146.39)",
    d: "M 99.947 118.457 c 10.678 0 21.358 0.113 32.033 -0.049 a 9.214 9.214 0 0 1 9.209 9.176 c -0.144 12.687 -0.04 25.377 -0.049 38.065 a 8.713 8.713 0 0 1 -8.743 8.715 q -32.45 0.008 -64.9 0 a 8.669 8.669 0 0 1 -8.893 -8.866 q -0.027 -19.033 0 -38.066 a 8.626 8.626 0 0 1 9 -8.968 q 16.173 -0.03 32.346 -0.006 Z m -0.008 24.281 q -18.719 0 -37.439 -0.015 c -0.9 0 -1.284 0.164 -1.278 1.189 c 0.044 7.037 0.01 14.074 0.029 21.111 c 0.011 4.1 2.635 6.694 6.729 6.695 q 31.927 0.005 63.854 0 a 6.265 6.265 0 0 0 6.658 -6.658 q 0.015 -10.452 0 -20.9 c 0 -1.413 -0.009 -1.415 -1.427 -1.415 Z m -0.067 -2.645 q 18.67 0 37.341 0.019 c 0.983 0 1.324 -0.261 1.3 -1.279 q -0.09 -4.523 0 -9.048 c 0.02 -0.992 -0.324 -1.215 -1.256 -1.211 c -7.281 0.033 -14.562 0.018 -21.843 0.018 q -26.42 0 -52.839 -0.022 c -1.036 0 -1.384 0.262 -1.359 1.333 c 0.069 3.015 0.057 6.033 0 9.048 c -0.017 0.94 0.31 1.16 1.2 1.158 Q 81.15 140.071 99.872 140.093 Z m 0 -14.146 H 137 c 1.362 0 1.466 -0.159 0.81 -1.388 a 6.271 6.271 0 0 0 -5.96 -3.45 q -17.21 -0.009 -34.419 -0.007 q -14.714 0 -29.428 0 a 6.349 6.349 0 0 0 -6.059 3.469 c -0.661 1.238 -0.566 1.378 0.811 1.378 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.4 0 0 0.4 10.4 0.53)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#012670",
    style: {
      fill: "#012670",
      stroke: "rgb(0,0,0)",
      strokeWidth: 0.6,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-337.52, -290.56)",
    d: "M 340.416 297.074 c -1.756 -0.771 -3.76 -0.383 -5.844 -0.151 c -3.376 0.376 -6.127 -2.306 -6.6 -5.949 c -0.378 -2.88 2 -6.059 5.007 -6.774 a 5.717 5.717 0 0 1 3.554 0.3 a 2.317 2.317 0 0 0 1.781 0 a 6.467 6.467 0 1 1 3.726 12.349 C 341.6 296.954 341.149 296.976 340.416 297.074 Z m -2.505 -6.544 a 3.684 3.684 0 0 0 -3.644 -3.734 a 3.706 3.706 0 1 0 -0.013 7.412 A 3.588 3.588 0 0 0 337.911 290.531 Z m 6.437 0.016 a 3.694 3.694 0 0 0 -3.731 -3.752 c -0.593 0.013 -0.952 0.06 -0.582 0.818 a 6.311 6.311 0 0 1 -0.015 5.886 c -0.309 0.609 -0.053 0.7 0.48 0.735 A 3.58 3.58 0 0 0 344.348 290.547 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.4 0 0 0.4 -8.32 0.66)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#012670",
    style: {
      fill: "#012670",
      stroke: "rgb(0,0,0)",
      strokeWidth: 0.6,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-106.03, -311.96)",
    d: "M 106.017 313.276 q -4.783 0 -9.567 0 c -1.165 0 -1.726 -0.443 -1.727 -1.318 s 0.56 -1.318 1.729 -1.319 q 9.567 -0.009 19.133 -0.007 c 0.653 0 1.261 0.066 1.6 0.728 c 0.487 0.962 -0.177 1.906 -1.391 1.913 c -3.085 0.019 -6.17 0.006 -9.255 0.006 Z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardOutline);
export default __webpack_public_path__ + "static/media/CreditCardOutline.e4d394cb0be96d82a18b82a8beb73adc.svg";
export { ForwardRef as ReactComponent };